<template>
  <div class="addModel myinput">
    <div class="addemBtns">
      编辑仪器柜
    </div>
    <div class="addem">
      <span>仪器柜规格</span>
      <el-select disabled v-model="value" @change="setValue" placeholder="请选择仪器柜规格" popper-class="select_option" :popper-append-to-body="false">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="addem">
      <span>编号</span>
      <el-input v-model="emId" maxlength="8"></el-input>
    </div>
    <div class="addem">
      <span>名称</span>
      <el-input v-model="emName" maxlength="100"></el-input>
    </div>
    <div class="detailed">
      <div class="element-list jb-bg btn" @click="submit">确认</div>
      <div class="element-list jb-bg btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
export default {
  props:['checkListChoseL'],
  data() {
    return {
      ckVal: 1,
      depotId:'', //仓库id
      //仪器柜
      emX: "2", //仪器柜行
      emY: "", //仪器柜列
      emId: "", //仪器柜编号
      emName:'', //仪器柜名称
      choseOption:{}, //选择规格
      options: [
        {value: 3, label: '2x3'},
        {value: 4, label: '2x4'},
        {value: 5, label: '2x5'},
        {value: 6, label: '2x6'},
        {value: 7, label: '2x7'},
        {value: 8, label: '2x8'},
        {value: 9, label: '2x9'},
        {value: 10, label: '2x10'}
      ],
      value: ''
    };
  },
  created() {
    this.showMessageOption()
    this.depotId = sessionStorage.getItem('depotId');
  },
  methods: {
    showMessageOption(){
      console.log(this.checkListChoseL[0].number)
      this.value = this.checkListChoseL[0].row
      this.emId = this.checkListChoseL[0].number
      this.emName = this.checkListChoseL[0].name
      this.emY = this.checkListChoseL[0].row
      this.emX = this.checkListChoseL[0].column
      /*this.choseOption =  this.options.find((item,index)=>item.value === this.checkListChoseL[0].row);*/

    },
    setValue(){
      this.emY = this.value
    },
    isNumber(str) {
    var reg = /^\d+$/;
    return reg.test(str);
},
    submit() {
      if (!this.emId) {
        return this.$message.error('编号不能为空!')
      }
    
      if (!this.isNumber(this.emId)) {
          return this.$message.error('编号格式错误，请输入数字')
      }
      if(this.emName.trim() == ''){
        return this.$message.error('名称不能为空！')
      }
      let data1 = {
        id:this.checkListChoseL[0].id,
        number: this.emId,
        name: this.emName,
        column: parseInt(this.emX),
        row: parseInt(this.emY),
        deptId: Number(this.$store.state.user.userInfo.deptId),
        depotId: Number(this.depotId),
      };
      console.log(data1)
      this.$emit("submit", data1);
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style lang='less' scoped>
.select_option{
  background: #092e5f !important;
  color: #ffffff !important;
}
.addModel {
  height: 300px;
  color: #74c8fe;
  margin: 0 30px;
  .addemBtns {
    margin: 30px 10px;
    font-size:20px
  }
  .addem {
    display: flex;
    height: 50px;
    line-height: 50px;
    margin: 0 5px;
    .el-input {
      width: 260px;
      margin: 0px 15px;
    }
    span {
      width: 85px;
      text-align: center;
      text-align-last: justify;
    }
    .el-select{
      width: 260px;
      margin: 0 15px;
    }
  }
  .detailed {
    margin: 0 20px 20px;
    clear: both;
    display: flex;
    position: absolute;
    bottom: 0px;
    .btn {
      width: 150px;
      margin-right: 10px;
      cursor: pointer;
    }

    .element-list {
      border: 2px solid#0090F0;
      border-radius: 6px;
      height: 30px;
      line-height: 30px;
      margin: 10px 5px;
      text-align: center;
    }
    .jb-bg {
      background-image: linear-gradient(#0479b4, #02407e);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/editModel.vue